<ngx-extended-pdf-viewer
  zoom="page-fit"
  language="en-US"
  [customToolbar]="customToolbar"
  [src]="source()"
  [handTool]="false"
  [textLayer]="true"
  [showFindButton]="true"
  [showRotateButton]="false"
  [showRotateCwButton]="false"
  [showRotateCcwButton]="false"
  [showPresentationModeButton]="false"
  [showPagingButtons]="false"
  [showDrawEditor]="false"
  [showStampEditor]="false"
  [showTextEditor]="false"
  [showZoomButtons]="true"
  [showHighlightEditor]="false"
  [showSecondaryToolbarButton]="false"
  [showOpenFileButton]="false"
  [showPrintButton]="false"
  [showDownloadButton]="false"
  [showSidebarButton]="false"
/>

<ng-template #customToolbar>
  <div id="toolbarViewer">
    <div id="toolbarViewerLeft"></div>
    <div class="pdf-toolbar-viewer-content">
      <pdf-find-button
        [showFindButton]="true"
        [textLayer]="true"
        [hasTextLayer]="true"
        [findbarVisible]="false"
      />
      <pdf-zoom-toolbar
        id="toolbarViewerMiddleContainer"
        [showZoomButtons]="true"
        [showZoomDropdown]="true"
      />
    </div>
    <div id="toolbarViewerRight"></div>
  </div>
</ng-template>
